<template>
    <div class="modal fade show">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header my-modal-header">
                    <div class="row">
                        <div class="col-10">
                            <h5 class="mt-0 font-size-12 text-primary">{{ name }}</h5>
                            <p class="card-title-desc">Exportar dados do Board</p>
                        </div>
                        <div class="col-2">
                            <button type="button" class="btn-close float-end" @click="closeModalExport()"></button>
                        </div>
                    </div>
                </div>
                <div class="modal-body my-modal-body">
                    <div class="tab-content">
                        <div class="tab-pane active">
                            <div class="row">
                                <div class="col-4 mt-3" v-for="m in meses_disponiveis" :key="m.id">
                                    <label v-if="m.status === true" :for="`input-${m.id}`" class="normal-label active">
                                        <input type="checkbox" :name="`value-${m.id}`" :id="`input-${m.id}`"
                                            :checked="meses_form.includes(m.id)" @change="addMes(m.id)">
                                        <span>{{ m.value }}</span>
                                    </label>
                                    <label v-else class="normal-label disabled">
                                        <span class="fake-input-checkbox"></span>
                                        <span>{{ m.value }}</span>
                                    </label>
                                </div>
                                <div class="col-12 mt-3">
                                    <a class="btn btn-primary bg-gray w-100 waves-effect waves-light"
                                        @click="handleExport"> Exportar </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { status, meses, formatos } from '../../../data/data-static.js'
//import AppInputDate from "@/components/AppInputDate/AppInputDate.vue";
import { mapActions } from "vuex";
export default {
    props: {
        board: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: null
        },
    },
    components: {
    },
    data() {
        return {
            meses_disponiveis: {},
            meses_form: [],
            data_init: null,
            data_end: null,
        }
    },
    created() {
        const refNow = new Date();
        const refMes = refNow.getMonth() + 1
        const temp = [];
        meses.forEach(m => {
            if (refMes >= m.id) {
                temp.push({
                    ...m,
                    status: true
                })
            } else {
                temp.push({
                    ...m,
                    status: false
                })
            }
        })
        this.meses_disponiveis = temp;
    },
    methods: {
        ...mapActions([
            "showMessage",
            "showLoader"
        ]),
        addMes(m) {
            const idx = this.meses_form.indexOf(m);
            if (idx > -1) {
                console.log('remover', m)
                this.meses_form.splice(idx, 1);
            } else {
                console.log('adicionar', m)
                this.meses_form.push(m);
            }

            console.log('resultado', this.meses_form)
        },
        getFor(id, status) {
            if (status === false) return null;
            return `input-${id}`
        },
        closeModalExport() {
            this.$emit("setModalExportShow");
        },
        updateDatas(v = null, n = null) {
            if (n === 'date_init') {
                this.data_init = v;
            }
            else if (n === 'date_end') {
                this.data_end = v;

                const inputDate = new Date(v);
                const now = new Date();
                const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

                if (inputDate > tomorrow) {
                    this.showMessage({
                        title: "A data de término não deverá ser igual ou maior que o dia de amanhã.",
                        css: "bg-danger"
                    });
                    this.data_end = null;
                }
            }
        },
        async handleExport() {
            if (this.meses_form.length === 0) return false;


            this.showLoader(true);
            const data = { data_array: this.meses_form };
            const response = await this.$AppCallApi("POST", `board-export/${this.$route.params.id}`, data);

            if (response && response.data) {
                this.showLoader(false);
                this.showMessage({
                    title: "Arquivo gerado com sucesso.",
                    css: "bg-success"
                });
                const downloadUrl = response.data.data.url;
                const a = document.createElement("a");
                a.href = downloadUrl;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                const _this = this;
                setTimeout(function () {
                    _this.closeModalExport();
                }, 1500)
            } else {
                let title_message = "Nada para exportar no mês selecionado."
                if(this.meses_form.length > 1){
                    title_message = "Nada para exportar nos meses selecionados."
                }
                this.showLoader(false);
                this.showMessage({
                    title: title_message,
                    css: "bg-danger"
                });
            }
        }
    }
}
</script>
<style scoped>
.normal-label {
    position: relative;
    float: left;
    width: 100%;
    top: 0px;
}

.normal-label input,
.normal-label label {
    position: relative;
    float: left;
    top: 0px;
    margin-right: 10px;
}

.normal-label label {
    padding: 0px;
}

.normal-label.active {
    cursor: pointer;
}

.normal-label.active::before {
    position: absolute;
    float: left;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    content: "";
    z-index: 6;
}

.normal-label.disabled {
    opacity: .7;
    cursor: not-allowed;
}

span.fake-input-checkbox {
    width: 14px;
    height: 14px;
    background: #f1f1f1;
    position: relative;
    float: left;
    border-radius: 3px;
    border: 1px solid #ccc;
    margin-right: 10px;
}

.nav-link.btn {
    border-radius: 0px;
    background: transparent;
    color: #000;
}

.nav-link.btn.active {

    color: #000;
    background: #FFF;
}

.nav>.nav-item:first-child>.nav-link.btn {
    border-top-left-radius: 8px;
}

.nav>.nav-item:last-child>.nav-link.btn {
    border-top-right-radius: 8px;
}

ul.list-users {
    max-height: 250px;
    overflow-x: auto;
    border-top: 1px solid #ddd;
    border-radius: 4px;
}

ul.list-users,
ul.list-users li {
    margin: 0px;
    padding: 0px;
    list-style: none;
}

ul.list-users li {
    display: flex;
    justify-content: space-between;
    border: 1px solid #ddd;
    border-top: none;
}

ul.list-users li>a {
    margin-right: 10px;
    cursor: pointer;
}

.remove-btn {
    padding: 0px;
    font-size: 14px;
    line-height: 14px;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    margin-right: 0px;
    text-align: center;
}

.modal.show {
    display: block;
    background: rgba(0, 102, 255, 0.5);
}

.modal-content {
    box-shadow: 0 0.75rem 1.5rem rgba(255, 255, 255, 0.3);
    background: #f1f2f4;
    border-radius: 0px !important;
}

.tab-content {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
}

.my-modal-header {
    display: block;
}

.my-modal-header,
.modal-body {
    padding: 2rem;
    border: none !important;
}

.my-modal-header {
    padding-bottom: 0rem;
}

.modal-body {
    padding-top: 0rem;
}

.my-modal-header h5 {
    display: block;
}

.btn-close {
    margin-top: -5px;
}

.btn-fixed-right {
    position: fixed;
    float: left;
    right: -200px;
    width: 150px;

}
</style>